import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Container,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import StyledButton from 'flaivy-react/components/StyledButton';
import FilterPanel from './FilterPanel';
import IconX from '../icons/IconX';

function FilterPanelModal({
  onChange,
  querySpecification,
  shopConfig,
  articleListConfig,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [filterPanelValues, setFilterPanelValues] =
    useState(querySpecification);
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setFilterPanelValues(querySpecification);
  }, [querySpecification]);

  const handleChange = newQuerySpecification => {
    setFilterPanelValues(newQuerySpecification);
  };

  const applyFilters = () => {
    onChange(filterPanelValues);
    setIsOpen(false);
  };
  return (
    <div>
      <Modal isOpen={isOpen} centered>
        <ModalBody className="filterPanelModalBody">
          <Container>
            <Row>
              <Col xs={12} className="text-end">
                <Button
                  onClick={toggleModal}
                  aria-label="Close"
                  className="close-rotate pe-0"
                  color="none"
                >
                  <IconX height="20" />
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <FilterPanel
                  onChange={handleChange}
                  querySpecification={filterPanelValues}
                  shopConfig={shopConfig}
                  articleListConfig={articleListConfig}
                />
              </Col>
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <StyledButton onClick={applyFilters} block>
            Visa artiklar
          </StyledButton>
        </ModalFooter>
      </Modal>
      <StyledButton color="outline-dark" onClick={toggleModal}>
        <div>
          Filter & genvägar
          <FontAwesomeIcon className="ms-2" icon={faSlidersH} size="sm" />
        </div>
      </StyledButton>
    </div>
  );
}

FilterPanelModal.propTypes = {
  onChange: PropTypes.func.isRequired,
  shopConfig: PropTypes.object.isRequired,
  querySpecification: PropTypes.object,
  articleListConfig: PropTypes.object,
};

FilterPanelModal.defaultProps = {
  querySpecification: null,
  articleListConfig: null,
};
export default FilterPanelModal;
